import { render, staticRenderFns } from "./GeneIcon.vue?vue&type=template&id=fe35c564&scoped=true"
import script from "./GeneIcon.vue?vue&type=script&lang=js"
export * from "./GeneIcon.vue?vue&type=script&lang=js"
import style0 from "./GeneIcon.vue?vue&type=style&index=0&id=fe35c564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe35c564",
  null
  
)

export default component.exports